/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadsBulkRequestDocumentsInner
 */
export interface CreateLeadsBulkRequestDocumentsInner {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    s3_key: string;
}

/**
 * Check if a given object implements the CreateLeadsBulkRequestDocumentsInner interface.
 */
export function instanceOfCreateLeadsBulkRequestDocumentsInner(value: object): value is CreateLeadsBulkRequestDocumentsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function CreateLeadsBulkRequestDocumentsInnerFromJSON(json: any): CreateLeadsBulkRequestDocumentsInner {
    return CreateLeadsBulkRequestDocumentsInnerFromJSONTyped(json, false);
}

export function CreateLeadsBulkRequestDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadsBulkRequestDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        's3_key': json['s3_key'],
    };
}

export function CreateLeadsBulkRequestDocumentsInnerToJSON(json: any): CreateLeadsBulkRequestDocumentsInner {
    return CreateLeadsBulkRequestDocumentsInnerToJSONTyped(json, false);
}

export function CreateLeadsBulkRequestDocumentsInnerToJSONTyped(value?: CreateLeadsBulkRequestDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        's3_key': value['s3_key'],
    };
}

